// Utility to communicate with the parent native app (iOS, Android, Flutter).
import config from "./config";

type BridgeEventType =
  | "sessionFlowStarted"
  | "sessionLaunching"
  | "sessionLaunchSucceeded"
  | "sessionEnded"
  | "sessionError";

type BridgeErrorType =
  | "invalidConfiguration"
  | "invalidUser"
  | "launchFailed";

type BridgePayload =
  | null
  | undefined
  | string
  | Record<string, unknown>
  | {
    errorType?: BridgeErrorType;
    message?: string;
  };

type BridgeEvent = {
  type: BridgeEventType;
  payload?: BridgePayload;
};

export const NativeBridge = {
  // Send an event to the native host:
  emitToNative(event: BridgeEvent) {
    try {
      if (!config.enableNativeBridge) {
        console.log("[NativeBridge] Bridge not enabled, not sending:", event);
        return;
      }

      // iOS WKWebView
      if ((window as any).webkit?.messageHandlers?.bridge) {
        (window as any).webkit.messageHandlers.bridge.postMessage(event);
        return;
      }
      // Android WebView (addJavascriptInterface)
      if ((window as any).Android?.postMessage) {
        (window as any).Android.postMessage(JSON.stringify(event));
        return;
      }
      // Flutter webview_flutter (JavaScriptChannel)
      if ((window as any).FlutterBridge?.postMessage) {
        (window as any).FlutterBridge.postMessage(JSON.stringify(event));
        return;
      }
      console.warn("[NativeBridge] No native bridge found");
    } catch (e) {
      console.error("[NativeBridge] emitToNative failed:", e);
    }
  },

  // Native will call this from evaluateJavaScript / runJavaScript:
  //   window.NativeBridge.emitToWeb('someEvent', { ... })
  emitToWeb(type: string, payload?: unknown) {
    if (config.enableNativeBridge) {
      console.log("[NativeBridge] emitToWeb", type, payload);
      window.dispatchEvent(new CustomEvent(type, { detail: payload }));
    } else {
      console.log("[NativeBridge] Bridge not enabled, ignoring emitToWeb", type, payload);
    }
  },
};